export default __webpack_public_path__ + "static/media/1.ec8e5912.webp";